import { useState } from 'react';
import type { GistFeedReply, GistPostView } from '@london-life/contracts';
import { GistFeed } from './feed';
import { GistFollowButton } from './search';
import { GistAvatar, type GistNav } from './parts';

// A player's page, as Lagos: a banner, their picture, Message and Follow (someone else), their name, then their
// posts; your own (Me) has your Bookmarks beside your posts, which only you see.
export function GistProfilePage({
  lifeId,
  nav,
  onChat,
  onReply,
  added,
}: {
  // null: your own
  lifeId: string | null;
  nav: GistNav;
  onChat?: (lifeId: string) => void;
  onReply?: (reply: GistFeedReply) => void;
  added?: GistPostView | null;
}) {
  const [tab, setTab] = useState<'posts' | 'bookmarks'>('posts');
  const [following, setFollowing] = useState<boolean | null>(null);
  const me = lifeId === null;
  const top = (reply: GistFeedReply) => {
    const profile = reply.profile;
    if (!profile) return null;
    const on = following ?? profile.following;
    return (
      <div className="gist-profile">
        <div className="gist-banner" aria-hidden="true" />
        <div className="gist-profile-top">
          <GistAvatar author={profile} size={72} />
          {!profile.me && (
            <span className="gist-profile-buttons">
              {onChat && (
                <button type="button" className="gist-message" onClick={() => onChat(profile.lifeId)}>
                  Message
                </button>
              )}
              <GistFollowButton lifeId={profile.lifeId} on={on} onChange={setFollowing} />
            </span>
          )}
        </div>
        <h3 className="gist-profile-name">{profile.name}</h3>
        {me && (
          <div className="gist-tabs" role="tablist" aria-label="Your page">
            {(['posts', 'bookmarks'] as const).map((id) => (
              <button
                key={id}
                type="button"
                role="tab"
                aria-selected={tab === id}
                className={tab === id ? 'active' : ''}
                onClick={() => setTab(id)}
              >
                {id === 'posts' ? 'Posts' : 'Bookmarks'}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };
  return (
    <GistFeed
      key={`${lifeId ?? 'me'}:${tab}`}
      tab={me ? (tab === 'bookmarks' ? 'bookmarks' : 'mine') : 'user'}
      of={lifeId ?? undefined}
      nav={nav}
      top={top}
      onReply={onReply}
      added={added}
      empty={
        tab === 'bookmarks'
          ? {
              title: 'Save posts for later',
              body: 'Tap the bookmark on any post to find it here. Only you can see your bookmarks.',
            }
          : me
            ? { title: "You haven't posted yet", body: "What's the gist? Tap the ✏️ button to post." }
            : { title: 'No posts yet', body: 'When they post, it shows here.' }
      }
    />
  );
}
